class MapIndexAnimation {

    constructor () {
        this.opt = {
            svg: ".js-map-index",
            classOpen: "map-index-animation__block--open"
        };

        this.$svg = $(this.opt.svg);

        this.$lineRegular = $("#Regular-Map");
        this.$lineCharter = $("#Charter-Map");

        this.$lineRegular_Block = this.$lineRegular.find("#Group-2");
        this.$lineRegular_OrangeBlock = this.$lineRegular_Block.find("#Group-3").find("path");
        this.$lineRegular_BlueLineBlock = this.$lineRegular_Block.find("#Group-4").find("path");
        this.$lineRegular_BlueLineLongBlock = this.$lineRegular_Block.find("#Group-5").find("path");

        this.$lineCharter_Block = this.$lineCharter.find("#Charters-Lines");
        this.$lineCharter_LineOne = this.$lineCharter_Block.find("#Charter-1").find("path");
        this.$lineCharter_LineTwo = this.$lineCharter_Block.find("#Charter-2").find("path");
        this.$lineCharter_LineThree = this.$lineCharter_Block.find("#Charter-3").find("path");
        this.$lineCharter_LineFour = this.$lineCharter_Block.find("#Charter-4").find("path");
        this.$lineCharter_LineFive = this.$lineCharter_Block.find("#Charter-5").find("path");
        this.$lineCharter_LineSix = this.$lineCharter_Block.find("#Charter-6").find("path");

        this.StatusOpenAnimationRegular = true;
        this.StatusOpenAnimationCharter = true;
    }
    
    _Check_SVG () {
        const data = global.getHash();

        if (data.type === 'tabs') {
            this._Change_TypeSVG(data);
        } else if(!data.type) {
            this._Open_FirstSVG();
        }
    }

    _Change_TypeSVG (data) {
        const   $obj = $(`${this.opt.svg}[data-type='${data.name}']`),
                indexObj = this.$svg.index($obj);

        this.$svg.removeClass(this.opt.classOpen);

        $obj.addClass(this.opt.classOpen);

        if(indexObj) {
            this._Change_CharterSVG();
        } else {
            this._Change_RegularSVG();
        }
    }

    _Open_FirstSVG () {
        this.$svg.eq(0).addClass(this.opt.classOpen);

        this._Change_RegularSVG();
    }

    _Change_RegularSVG () {
        if(this.StatusOpenAnimationRegular) {
            this.StatusOpenAnimationRegular = false;

            this.$lineRegular_OrangeBlock
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1800, delay: 10 });

            this.$lineRegular_BlueLineBlock
                .velocity({ 'stroke-dashoffset': 1000 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 3500, delay: 100 });

            this.$lineRegular_BlueLineLongBlock
                .velocity({ 'stroke-dashoffset': 1500 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { 
                    duration: 3500, 
                    delay: 1100,
                    complete: () => {
                        this.StatusOpenAnimationRegular = true;
                    }
                });
        }
    }

    _Change_CharterSVG () {
        if(this.StatusOpenAnimationCharter) {
            this.StatusOpenAnimationCharter = false;

            this.$lineCharter_LineOne
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1500, delay: 100 });

            this.$lineCharter_LineTwo
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1500, delay: 200 });

            this.$lineCharter_LineThree
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1500, delay: 300 });

            this.$lineCharter_LineFour
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1500, delay: 400 });

            this.$lineCharter_LineFive
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { duration: 1500, delay: 500 });

            this.$lineCharter_LineSix
                .velocity({ 'stroke-dashoffset': 400 }, 0)
                .velocity({ 'stroke-dashoffset': 0 }, { 
                    duration: 1500, 
                    delay: 600,
                    complete: () => {
                        this.StatusOpenAnimationCharter = true;
                    } 
                });
        }
    }
}

let map = new MapIndexAnimation();
map._Check_SVG();

$(window).on('hashchange', function(){
    map._Check_SVG();
});


// WEBPACK FOOTER //
// ./frontend/components/map-index-animation/map-index-animation.js